module.exports = __webpack_public_path__ + "assets/img/36_573_big.230d7729.jpg";